import { assert_false } from '@shared/asserts/utils_asserts';
import { DTO_REQUEST__tokens_add } from '@shared/common/_requests/DTO_REQUEST__tokens_add';
import { RequestTokensDelete } from '@shared/common/_requests/request_tokens_delete';
import { RequestTokensUpdateVisibility } from '@shared/common/_requests/request_tokens_update_visibility';
import { RequestViewerAction } from '@shared/common/_requests/request_viewer_action';
import { DTO__base } from '@shared/common/DTO__base';
import { DTO_REQUEST__image_asset_filter } from '@shared/dto/+image/_requests/DTO_REQUEST__image_asset_filter';
import { DTO_REQUEST__image_asset_segment } from '@shared/dto/+image/_requests/DTO_REQUEST__image_asset_segment';
import { DTO_REQUEST__images_upload } from '@shared/dto/+image/DTO_REQUEST__images_upload';
import { RequestImageAiDescriptionCreateOrTranslate } from '@shared/dto/+image/image_ai_description/_requests/request_image_ai_description_create_or_translate';
import { DTOImageAiDescription } from '@shared/dto/+image/image_ai_description/dto_image_ai_description';
import { DTO__file_data } from '@shared/dto/+image/image_asset_base/DTO__file_data';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { DTO__image_crop_box } from '@shared/dto/+image/image_asset_base/DTO__image_crop_box';
import { DTO__image_segment } from '@shared/dto/+image/image_asset_base/DTO__image_segment';
import { DTO__position } from '@shared/dto/+image/image_asset_base_generation/DTO__position';
import { DTO_IMAGE_META__graph_field } from '@shared/dto/+image/meta/graph/DTO_IMAGE_META__graph_field';
import { DTO_IMAGE_META__graph_field_generated } from '@shared/dto/+image/meta/graph/DTO_IMAGE_META__graph_field_generated';
import { DTO_IMAGE_META__grid2d_cell_generation } from '@shared/dto/+image/meta/grid2d/DTO_IMAGE_META__grid2d_cell_generation';
import { RequestDiffusionModelsUDRent } from '@shared/dto/+model/reservation/_requests/request_diffusion_models_ud_rent';
import { DTO__ml_asset_reservation } from '@shared/dto/+model/reservation/DTO__ml_asset_reservation';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { DTO__ml_asset_lora_tag_frequency } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset_lora_tag_frequency';
import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+model/table/dto_diffusion_models_table_page_settings_ud';
import { DTODiffusionModelsTablePageUD } from '@shared/dto/+model/table/dto_diffusion_models_table_page_ud';
import { DTODiffusionModelsTableUD } from '@shared/dto/+model/table/dto_diffusion_models_table_ud';
import { RequestAuthRegister } from '@shared/dto/+user/auth/_requests/request_auth_register';
import { DTO_RESPONSE__auth_success } from '@shared/dto/+user/auth/_requests/response_auth_success';
import { DTO__user_credentials } from '@shared/dto/+user/auth/DTO__user_credentials';
import { DTOUser } from '@shared/dto/+user/entity/dto_user';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { DTOUserSupportMessage } from '@shared/dto/+user/user_support_message/dto_user_support_message';
import { DTOUserTutorialProgress } from '@shared/dto/+user/user_tutorial/dto_tutorial_progress';
import { RequestWordsTranslateFromEnglish } from '@shared/dto/+word/word_translated/_requests/request_words_translate_from_english';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTO__word_with_context } from '@shared/dto/+word/word_translated/DTO__word_with_context';
import { RequestWordsWithRelatedWordsCreate } from '@shared/dto/+word/word_with_related_words/_requests/request_words_with_related_words_create';
import { RequestWordsWithRelatedWordsGet } from '@shared/dto/+word/word_with_related_words/_requests/request_words_with_related_words_get';
import { RequestWordsWithRelatedWordsTranslateFromEnglish } from '@shared/dto/+word/word_with_related_words/_requests/request_words_with_related_words_translate_from_english';
import { DTOWordWithRelatedWords } from '@shared/dto/+word/word_with_related_words/dto_word_with_related_words';
import { DTOWorkspaceBalance } from '@shared/dto/+workspace/workspace_balance/dto_workspace_balance';
import { DTOWorkspaceCreditTransaction } from '@shared/dto/+workspace/workspace_credit_transaction/dto_workspace_credit_transaction';
import { DTO__workspace_child_enity } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/dto_workspace_child_enity';
import { RequestWorkspaceChildEntityDelete } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_child_entity_delete';
import { RequestWorkspaceChildEntityUpdateShareStatus } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_child_entity_update_share_status';
import { RequestWorkspaceUpdateAvatar } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_update_avatar';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { DTOWorkspaceChildEntityViewer } from '@shared/dto/+workspace/workspace_entity/dto_workspace_child_entity_viewer';
import { RequestBuyCredits } from '@shared/dto/+workspace/workspace_payment_transaction.ts/_requests/request_buy_credits';
import { DTOworkspacePaymentTransactionStripe } from '@shared/dto/+workspace/workspace_payment_transaction.ts/dto_workspace_payment_transaction_stripe';
import { DTOWorkspaceSubscription } from '@shared/dto/+workspace/workspace_subscription/dto_workspace_subscription';
import { RequestWorkspaceUserOwnershipTransferCreate } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/_requests/request_workspace_transfer_ownership_create';
import { RequestWorkspaceUserOwnershipTransferDelete } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/_requests/request_workspace_transfer_ownership_delete';
import { RequestWorkspaceTransferOwnershipReply } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/_requests/request_workspace_transfer_ownership_reply';
import { DTOWorkspaceTranserOwnershipProposal } from '@shared/dto/+workspace/workspace_transfer_ownership_proposal/dto_workspace_transfer_ownership_proposal';
import { RequestWorkspaceUserCreditsLimitReset } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_reset';
import { RequestWorkspaceUserCreditsLimitUpdate } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_update';
import { RequestWorkspaceUserCreditsLimitUpdateStatus } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_update_status';
import { RequestWorkspaceUserDelete } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_delete';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { RequestWorkspaceUserInvitationCreate } from '@shared/dto/+workspace/workspace_user_invitation/_requests/request_workspace_user_invitation_create';
import { RequestWorkspaceUserInvitationReply } from '@shared/dto/+workspace/workspace_user_invitation/_requests/request_workspace_user_invitation_reply';
import { DTOWorkspaceUserInvitation } from '@shared/dto/+workspace/workspace_user_invitation/dto_workspace_user_invitation';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { DTO__app_info } from '@shared/dto/app_info/DTO__app_info';
import { DTO_REQUEST__collection_image_add } from '@shared/dto/collection/_requests/DTO_REQUEST__collection_image_add';
import { DTO_REQUEST__collection_image_delete } from '@shared/dto/collection/_requests/DTO_REQUEST__collection_image_delete';
import { RequestCollectionUpdateName } from '@shared/dto/collection/_requests/request_collection_update_name';
import { RequestCollectionUpdateVisibility } from '@shared/dto/collection/_requests/request_collection_update_visibility';
import { ResponseCollectionSpecialInfo } from '@shared/dto/collection/_requests/response_collection_images_ids_in_special_collections';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { DTO_REQUEST__generation_consume_content } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_consume_content';
import { DTO_REQUEST__generation_create } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create';
import { DTO_REQUEST__generation_create_for_field_consumer } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_create_for_field_consumer';
import { DTO_REQUEST__generation_start } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_start';
import { DTO_REQUEST__generation_update } from '@shared/dto/generation/_requests/DTO_REQUEST__generation_update';
import { RequestGenerationAdjustingAdd } from '@shared/dto/generation/_requests/request_generation_duration_adjusting_add';
import { RequestGenerationUpdateName } from '@shared/dto/generation/_requests/request_generation_update_name';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__generation_tool } from '@shared/dto/generation/DTO__generation_tool';
import { DTO__generation_tool_grid2d_view } from '@shared/dto/generation/DTO__generation_tool_grid2d_view';
import { ERROR_GRAPH__edge } from '@shared/dto/generation/graph_invoke/_errors/ERROR_GRAPH__edge';
import { ERROR_GRAPH__field } from '@shared/dto/generation/graph_invoke/_errors/ERROR_GRAPH__field';
import { ERROR_GRAPH__graph } from '@shared/dto/generation/graph_invoke/_errors/ERROR_GRAPH__graph';
import { ERROR_GRAPH__node } from '@shared/dto/generation/graph_invoke/_errors/ERROR_GRAPH__node';
import { DTO_META__field_info } from '@shared/dto/generation/graph_invoke/_fields/_base/DTO_META__field_info';
import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';
import { FIELD_PRIMITIVE__seed } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__seed';
import { FIELD__list_control_net } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_control_net';
import { FIELD__list_float } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_float';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { FIELD__list_ip_adapter } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_ip_adapter';
import { FIELD__list_lora } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_lora';
import { FIELD__list_t2i_adapter } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_t2i_adapter';
import { FIELD__list_tensor_image_mask_boolean } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_tensor_image_mask_boolean';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import { FIELD_PRIMITIVE__list_float_dynamic } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD_PRIMITIVE__list_float_dynamic';
import { FIELD_SD__list_conditioning } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD_SD__list_conditioning';
import { FIELD_SD__list_conditioning_masked } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD_SD__list_conditioning_masked';
import { FIELD_PRIMITIVE__float } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__float';
import { FIELD_PRIMITIVE__int } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_PRIMITIVE__int_image_side } from '@shared/dto/generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__int_image_side';
import { FIELD_PRIMITIVE__base_string } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/FIELD_PRIMITIVE__base_string';
import { FIELD_PRIMITIVE__string_enum } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/FIELD_PRIMITIVE__string_enum';
import { FIELD_PRIMITIVE__string_uuid } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/FIELD_PRIMITIVE__string_uuid';
import { FIELD_PRIMITIVE__string_hash_image_generated } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_image_generated';
import { FIELD_PRIMITIVE__string_hash_image_uploaded } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_image_uploaded';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';
import { FIELD_PRIMITIVE__string_hash_sha256 } from '@shared/dto/generation/graph_invoke/_fields/_primitives/string/hash/FIELD_PRIMITIVE__string_hash_sha256';
import { FIELD__tensor_image } from '@shared/dto/generation/graph_invoke/_fields/_tensor/FIELD__tensor_image';
import { FIELD__tensor_image_mask_boolean } from '@shared/dto/generation/graph_invoke/_fields/_tensor/FIELD__tensor_image_mask_boolean';
import { FIELD__tensor_latents } from '@shared/dto/generation/graph_invoke/_fields/_tensor/FIELD__tensor_latents';
import { FIELD__tensor_latents_masked } from '@shared/dto/generation/graph_invoke/_fields/_tensor/FIELD__tensor_latents_masked';
import { FIELD__any } from '@shared/dto/generation/graph_invoke/_fields/any/FIELD__any';
import { FIELD__any__list } from '@shared/dto/generation/graph_invoke/_fields/any/FIELD__any__list';
import { FIELD__any__ml_asset } from '@shared/dto/generation/graph_invoke/_fields/any/FIELD__any__ml_asset';
import { FIELD_SD__conditioning } from '@shared/dto/generation/graph_invoke/_fields/guidance/FIELD_SD__conditioning';
import { FIELD_SD__conditioning_masked } from '@shared/dto/generation/graph_invoke/_fields/guidance/FIELD_SD__conditioning_masked';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { FIELD__image_crop_box } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_crop_box';
import { FIELD__image_segments } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_segments';
import { FIELD__ml_asset_clip } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/FIELD__ml_asset_clip';
import { FIELD__ml_asset_unet } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/FIELD__ml_asset_unet';
import { FIELD__ml_asset_unet_free_u } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/FIELD__ml_asset_unet_free_u';
import { FIELD__ml_asset_vae } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/FIELD__ml_asset_vae';
import { FIELD__ml_asset_control_net } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance/FIELD__ml_asset_control_net';
import { FIELD__ml_asset_ip_adapter } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance/FIELD__ml_asset_ip_adapter';
import { FIELD__ml_asset_t2i_adapter } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance/FIELD__ml_asset_t2i_adapter';
import { FIELD__ml_asset_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD__ml_asset_lora';
import { FIELD_GRID2D_MODE__all_loras_except_one } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__all_loras_except_one';
import { FIELD_GRID2D_MODE__lora_after_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_after_lora';
import { FIELD_GRID2D_MODE__lora_vs_lora } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_vs_lora';
import { FIELD_GRID2D_MODE__single_lora_generation } from '@shared/dto/generation/graph_invoke/_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__single_lora_generation';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { FIELD_GRID2D_MODE__all_tokens_except_one } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__all_tokens_except_one';
import { FIELD_GRID2D_MODE__single_token_generation } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__single_token_generation';
import { FIELD_GRID2D_MODE__token_after_token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__token_after_token';
import { FIELD_GRID2D_MODE__token_vs_token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD_GRID2D_MODE__token_vs_token';
import { DTO_GRAPH__edge } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__edge';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { DTO_GRAPH_META__info } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH_META__info';
import { DTO_META__invocation_info } from '@shared/dto/generation/graph_invoke/_invocations/_base/DTO_META__invocation_info';
import { INVOCATION_GRID2D__view } from '@shared/dto/generation/graph_invoke/_invocations/grid2d/INVOCATION_GRID2D__view';
import { INVOCATION__image_mask_boolean_to_tensor } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION__image_mask_boolean_to_tensor';
import { INVOCATION_IMAGE__color_map } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__color_map';
import { INVOCATION_IMAGE__create_mask_gradient } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__create_mask_gradient';
import { INVOCATION_IMAGE__extend } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__extend';
import { INVOCATION_IMAGE__paste_with_mask } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__paste_with_mask';
import { INVOCATION_IMAGE__scale } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__scale';
import { INVOCATION_IMAGE__sharp } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__sharp';
import { INVOCATION_IMAGE__trim_color } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__trim_color';
import { INVOCATION_IMAGE__viewport } from '@shared/dto/generation/graph_invoke/_invocations/image/INVOCATION_IMAGE__viewport';
import { INVOCATION_TOOL_VIEW__info } from '@shared/dto/generation/graph_invoke/_invocations/info/INVOCATION_TOOL_VIEW__info';
import { INVOCATION_LATENTS__create_noise } from '@shared/dto/generation/graph_invoke/_invocations/latents/INVOCATION_LATENTS__create_noise';
import { INVOCATION_SD__denoise_latents_pipeline } from '@shared/dto/generation/graph_invoke/_invocations/sd/denoise/INVOCATION_SD__denoise_latents_pipeline';
import { INVOCATION_SD__control_net } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__control_net';
import { INVOCATION_SD__ip_adapter } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__ip_adapter';
import { INVOCATION_SD__lora_select } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__lora_select';
import { INVOCATION_SD__t2i_adapter } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__t2i_adapter';
import { INVOCATION_SD__text_encoder } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__text_encoder';
import { INVOCATION_SD__text_encoder_masked } from '@shared/dto/generation/graph_invoke/_invocations/sd/guidance/INVOCATION_SD__text_encoder_masked';
import { INVOCATION_SD__image_to_latents } from '@shared/dto/generation/graph_invoke/_invocations/sd/vae/INVOCATION_SD__image_to_latents';
import { INVOCATION_SD__latents_to_image } from '@shared/dto/generation/graph_invoke/_invocations/sd/vae/INVOCATION_SD__latents_to_image';
import { INVOCATION_SPANDREL__upscaler } from '@shared/dto/generation/graph_invoke/_invocations/spandrel/INVOCATION_SPANDREL__upscaler';
import { INVOCATION_SPANDREL__upscaler_to_side } from '@shared/dto/generation/graph_invoke/_invocations/spandrel/INVOCATION_SPANDREL__upscaler_to_side';
import { INVOCATION_VISION_ML__depth_anything } from '@shared/dto/generation/graph_invoke/_invocations/vision/depth/INVOCATION_VISION_ML__depth_anything';
import { INVOCATION_VISION_ML__rembg } from '@shared/dto/generation/graph_invoke/_invocations/vision/INVOCATION_VISION_ML__rembg';
import { INVOCATION_VISION_CV2__control_line_guidance_canny } from '@shared/dto/generation/graph_invoke/_invocations/vision/line_guidance/canny/INVOCATION_VISION_CV2__control_line_guidance_canny';
import { INVOCATION_VISION_CV2__control_line_guidance_canny_auto } from '@shared/dto/generation/graph_invoke/_invocations/vision/line_guidance/canny/INVOCATION_VISION_CV2__control_line_guidance_canny_auto';
import { INVOCATION_VISION_CV2__control_line_guidance_canny_semi_auto } from '@shared/dto/generation/graph_invoke/_invocations/vision/line_guidance/canny/INVOCATION_VISION_CV2__control_line_guidance_canny_semi_auto';
import { INVOCATION_VISION_ML__control_line_guidance_hed } from '@shared/dto/generation/graph_invoke/_invocations/vision/line_guidance/INVOCATION_VISION_ML__control_line_guidance_hed';
import { INVOCATION_VISION_ML__segment_segformer } from '@shared/dto/generation/graph_invoke/_invocations/vision/segment/INVOCATION_VISION_ML__segment_segformer';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { DTOTokenCreateData } from '@shared/dto/generation/settings/token/dto_token_create_data';
import { DTO__generation_price_data } from '@shared/dto/generation_price/DTO__generation_price_data';
import { DTO_REQUEST__generation_price_get } from '@shared/dto/generation_price/DTO_REQUEST__generation_price_get';
import { DTO_REQUEST__grid2d_chunk_load_cells } from '@shared/dto/grid2d/_requests/DTO_REQUEST__grid2d_chunk_load_cells';
import { DTO_REQUEST__grid2d_get_by_entity_type_and_id } from '@shared/dto/grid2d/_requests/DTO_REQUEST__grid2d_get_by_entity_type_and_id';
import { DTO_RESPONSE__grid2d_download_images } from '@shared/dto/grid2d/_requests/DTO_RESPONSE__grid2d_download_images';
import { RequestGrid2dDownloadImages } from '@shared/dto/grid2d/_requests/request_grid2d_download_images';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { DTO__grid2d_generation } from '@shared/dto/grid2d/DTO__grid2d_generation';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { DTO__grid2d_cell_generation } from '@shared/dto/grid2d_cell/DTO__grid2d_cell_generation';
import { DTO__grid2d_chunk } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk';
import { DTO__grid2d_chunk_generation } from '@shared/dto/grid2d_chunk/DTO__grid2d_chunk_generation';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { RequestUserTaskUpdateVisibility } from '@shared/dto/user_task/_requests/request_user_task_update_visibility';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { DTO_RESPONSE__error } from '@shared/network/DTO_RESPONSE__error';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { TYPE_CLASS_CONSTRUCTOR_DTO } from '@shared/types/types';
import { logi } from '@shared/utils/utils_logs';
import { DTO__image_size } from '../dto/+image/image_asset_base/DTO__image_size';
import { FN_SERIALIZATION__register_class } from './_methods/FN_SERIALIZATION__register_class';
import { FN_SERIALIZATION__register_class_dto } from './_methods/FN_SERIALIZATION__register_class_dto';

let is_initialized = false;

export function FN_INIT__class_mapping() {
  assert_false(is_initialized);

  FN_SERIALIZATION__register_class(ENUM__dto_class_name.OBJECT, Object);

  let classes: TYPE_CLASS_CONSTRUCTOR_DTO<DTO__base>[] = [
    MAP__serializable,
    DTO__position,

    DTO_REQUEST__image_asset_segment,
    DTO_REQUEST__image_asset_filter,

    DTO__image_crop_box,
    DTO__image_segment,
    DTO__workspace_child_enity,

    /*
     * REQUESTS
     */
    DTO_RESPONSE__error,
    DTO_RESPONSE__success,

    DTO_REQUEST__tokens_add,
    RequestTokensDelete,
    RequestTokensUpdateVisibility,
    RequestViewerAction,

    /*
     * ADMIN
     */

    /*
     * APP INFO
     */
    DTO__app_info,

    /*
     * AUTH
     */
    RequestAuthRegister,
    DTO_RESPONSE__auth_success,

    /*
     * BILLING
     */
    DTOWorkspaceBalance,
    DTOworkspacePaymentTransactionStripe,
    DTOWorkspaceCreditTransaction,

    /*
     * COLLECTION IMAGES
     */

    ResponseCollectionSpecialInfo,
    RequestCollectionUpdateName,
    RequestCollectionUpdateVisibility,
    DTO_REQUEST__collection_image_add,
    DTO_REQUEST__collection_image_delete,

    DTO__collection,

    /*
     * GENERATION
     */

    DTO_REQUEST__generation_start,
    DTO_REQUEST__generation_update,
    DTO_REQUEST__generation_create,
    DTO_REQUEST__generation_create_for_field_consumer,
    DTO_REQUEST__generation_consume_content,

    DTO__generation,
    DTO__generation_tool,
    DTO__generation_tool_grid2d_view,

    /*
     * GENERATION SETTINGS
     */
    RequestGenerationAdjustingAdd,
    RequestGenerationUpdateName,

    DTO__file_data,

    DTO_GRAPH__instance,
    DTO_GRAPH_META__info,

    DTO__image_size,
    DTOTokenCreateData,
    DTO__number_range,

    /*
     * GENERATION PRICE
     */

    DTO__generation_price_data,
    DTO_REQUEST__generation_price_get,
    /*
     * GRID2D
     */

    DTO_REQUEST__grid2d_chunk_load_cells,
    DTO_REQUEST__grid2d_get_by_entity_type_and_id,
    RequestGrid2dDownloadImages,
    DTO_RESPONSE__grid2d_download_images,

    DTO__grid2d,
    DTO__grid2d_generation,

    DTO__grid2d_chunk,
    DTO__grid2d_chunk_generation,

    DTO__grid2d_cell,
    DTO__grid2d_cell_generation,

    /*
     * USER TASKS
     */
    RequestUserTaskUpdateVisibility,

    DTO__user_task,

    DTO_GRAPH__edge,

    /*
     * FIELDS
     */
    DTO_META__field_info,

    FIELD__any,
    FIELD__any__list,
    FIELD__any__ml_asset,

    FIELD__tensor_latents_masked,
    FIELD__tensor_latents,
    FIELD__tensor_image,
    FIELD__tensor_image_mask_boolean,

    FIELD_SD__conditioning,
    FIELD_SD__conditioning_masked,

    FIELD_PRIMITIVE__int,
    FIELD_PRIMITIVE__int_image_side,
    FIELD_PRIMITIVE__float,
    //
    FIELD_PRIMITIVE__seed,
    //
    FIELD_PRIMITIVE__bool,
    //
    FIELD_PRIMITIVE__base_string,
    FIELD_PRIMITIVE__string_enum,
    FIELD_PRIMITIVE__string_hash_ml_asset,
    FIELD_PRIMITIVE__string_hash_image_generated,
    FIELD_PRIMITIVE__string_hash_image_uploaded,
    FIELD_PRIMITIVE__string_hash_sha256,
    FIELD_PRIMITIVE__string_uuid,

    FIELD__token,

    FIELD_GRID2D_MODE__token_after_token,
    FIELD_GRID2D_MODE__token_vs_token,
    FIELD_GRID2D_MODE__single_token_generation,
    FIELD_GRID2D_MODE__all_tokens_except_one,

    FIELD_GRID2D_MODE__lora_vs_lora,
    FIELD_GRID2D_MODE__lora_after_lora,
    FIELD_GRID2D_MODE__single_lora_generation,
    FIELD_GRID2D_MODE__all_loras_except_one,

    //
    FIELD__image_asset,
    //
    FIELD__image_crop_box,
    FIELD__image_segments,

    //
    FIELD__ml_asset_clip,
    FIELD__ml_asset_lora,
    FIELD__ml_asset_vae,

    FIELD__ml_asset_unet,
    FIELD__ml_asset_unet_free_u,

    FIELD__ml_asset_control_net,
    FIELD__ml_asset_ip_adapter,

    FIELD__ml_asset_t2i_adapter,

    //
    FIELD_PRIMITIVE__list_float_dynamic,
    FIELD__list_float,

    FIELD__list_image_asset,
    FIELD_SD__list_conditioning,
    FIELD_SD__list_conditioning_masked,
    FIELD__list_tensor_image_mask_boolean,

    FIELD__list_token,
    FIELD__list_lora,
    FIELD__list_control_net,
    FIELD__list_ip_adapter,
    FIELD__list_t2i_adapter,

    /*
     * ERRORS
     */

    ERROR_GRAPH__edge,
    ERROR_GRAPH__node,
    ERROR_GRAPH__field,
    ERROR_GRAPH__graph,

    /*
     * INVOCATIONS
     */
    DTO_META__invocation_info,

    //

    INVOCATION_LATENTS__create_noise,
    INVOCATION_SD__text_encoder,
    INVOCATION_SD__text_encoder_masked,
    INVOCATION_SD__denoise_latents_pipeline,
    INVOCATION_SD__latents_to_image,
    INVOCATION_SD__image_to_latents,
    INVOCATION_SD__lora_select,
    INVOCATION_SD__control_net,
    INVOCATION_SD__ip_adapter,
    INVOCATION_SD__t2i_adapter,

    INVOCATION__image_mask_boolean_to_tensor,

    /*
     *
     */

    INVOCATION_TOOL_VIEW__info,
    /*
     *
     */
    INVOCATION_IMAGE__create_mask_gradient,
    INVOCATION_IMAGE__viewport,
    INVOCATION_IMAGE__color_map,
    INVOCATION_IMAGE__paste_with_mask,
    INVOCATION_IMAGE__extend,
    INVOCATION_IMAGE__trim_color,
    INVOCATION_IMAGE__sharp,
    INVOCATION_IMAGE__scale,

    /*
     *
     */

    INVOCATION_SPANDREL__upscaler,
    INVOCATION_SPANDREL__upscaler_to_side,

    /*
     *
     */
    INVOCATION_GRID2D__view,

    /*
     *
     */
    INVOCATION_VISION_CV2__control_line_guidance_canny,
    INVOCATION_VISION_CV2__control_line_guidance_canny_auto,
    INVOCATION_VISION_CV2__control_line_guidance_canny_semi_auto,
    INVOCATION_VISION_ML__control_line_guidance_hed,
    INVOCATION_VISION_ML__depth_anything,
    INVOCATION_VISION_ML__segment_segformer,

    INVOCATION_VISION_ML__rembg,

    /*
     * IMAGE
     */

    DTO_IMAGE_META__graph_field,
    DTO_IMAGE_META__graph_field_generated,

    DTO_IMAGE_META__grid2d_cell_generation,

    DTO__image_asset,

    /*
     * IMAGE AI DESCRIPTION
     */
    RequestImageAiDescriptionCreateOrTranslate,
    DTOImageAiDescription,

    /*
     * MODELS
     */
    RequestDiffusionModelsUDRent,

    DTO__ml_asset,
    DTO__ml_asset_reservation,
    DTO__ml_asset_lora_tag_frequency,

    /*
     * MODEL TABLES
     */

    DTODiffusionModelsTablePageSettingsUD,
    DTODiffusionModelsTablePageUD,
    DTODiffusionModelsTableUD,

    /*
     * SEARCH
     */
    DTOSearchSettings,

    /*
     * USER
     */

    DTOUser,
    DTO__user_credentials,
    DTO__user_settings,
    DTOUserTutorialProgress,
    DTOUserSupportMessage,

    /*
     * WORD TRANSLATED
     */
    RequestWordsTranslateFromEnglish,

    DTO__word,
    DTO__word_with_context,

    /*
     * WORD WITH RELATED WORDS
     */
    RequestWordsWithRelatedWordsGet,
    RequestWordsWithRelatedWordsCreate,
    RequestWordsWithRelatedWordsTranslateFromEnglish,

    DTOWordWithRelatedWords,

    /*
     * WORKSPACE BILLING
     */

    DTOWorkspaceSubscription,
    RequestBuyCredits,

    /*
     * WORKSPACE
     */
    DTO_REQUEST__images_upload,

    RequestWorkspaceUserDelete,

    RequestWorkspaceUserCreditsLimitUpdateStatus,
    RequestWorkspaceUserCreditsLimitUpdate,
    RequestWorkspaceUserCreditsLimitReset,

    RequestWorkspaceChildEntityUpdateShareStatus,
    RequestWorkspaceChildEntityDelete,
    RequestWorkspaceUpdateAvatar,

    RequestWorkspaceUserInvitationReply,
    RequestWorkspaceUserInvitationCreate,

    RequestWorkspaceUserOwnershipTransferCreate,
    RequestWorkspaceTransferOwnershipReply,
    RequestWorkspaceUserOwnershipTransferDelete,

    DTO__workspace,
    DTOWorkspaceChildEntityViewer,
    DTO__workspace_user,
    DTOWorkspaceUserInvitation,
    DTOWorkspaceTranserOwnershipProposal,
  ];

  for (let class_object of classes) FN_SERIALIZATION__register_class_dto(class_object);

  logi(`🛜  dto classes\t\t${Object.values(classes).length}`);

  is_initialized = true;
}
